import { IconProps } from "@/common/contracts/icon.contracts";

export const TikTok = (props: IconProps) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_13507_144791)">
        <path
          d="M7.60744 2.02993C11.3397 1.92795 15.1032 2.1276 18.8355 2.09169C21.0381 2.34807 22.3254 3.92479 22.446 6.09363C22.5168 7.3619 22.446 8.63412 22.4428 9.89951C22.4356 12.5086 22.5724 15.2889 22.446 17.8743C22.3254 20.3408 20.8198 21.8116 18.3705 21.9499C17.1026 22.0213 15.8289 21.9499 14.5646 21.9466C11.9742 21.9394 9.23047 22.0694 6.66162 21.9499C4.21521 21.8357 2.68697 20.3685 2.55016 17.9102C2.47691 16.5949 2.5498 15.2728 2.55339 13.9607C2.56058 11.4059 2.43203 8.69911 2.55016 6.16545C2.60905 4.91154 2.98788 3.83574 3.95165 3.00627C5.03607 2.07302 6.24724 2.06692 7.60744 2.02993ZM9.93822 3.90504C8.79635 3.91474 6.78443 3.7905 5.81563 4.35569C4.21773 5.2875 4.46011 7.01862 4.42671 8.61221C4.37931 10.8572 4.38147 13.1147 4.42671 15.3593C4.44754 16.3938 4.31683 17.7476 4.84145 18.6661C5.76069 20.2755 7.48822 20.0406 9.07858 20.0744C11.3444 20.1229 13.6231 20.1207 15.8885 20.0744C17.4954 20.0413 19.2527 20.2841 20.1687 18.646C20.5214 18.0154 20.5084 17.4718 20.5404 16.7784C20.6614 14.174 20.6183 11.4748 20.572 8.86465C20.5429 7.22006 20.8381 5.32053 19.1831 4.35569C18.4915 3.95244 17.8854 3.98835 17.1202 3.95855C14.7696 3.86734 12.2988 3.88529 9.93786 3.90504H9.93822Z"
          fill="currentColor"
        />
        <path
          d="M17.5972 8.33898V10.9243C16.7595 10.8177 15.9558 10.5028 15.2635 10.0266L15.2628 14.5686C15.0703 17.0739 12.6857 18.7569 10.2447 18.0794C9.1836 17.7849 8.15986 16.9034 7.72753 15.8926C6.51779 13.0616 8.85612 9.99038 11.8878 10.4575V12.612C10.7704 12.2799 9.61952 13.0289 9.55237 14.2081C9.46332 15.7651 11.2903 16.6366 12.4796 15.6631C12.7532 15.4391 13.1087 14.8534 13.1087 14.4968V5.91519L13.1626 5.86133H14.6348C14.7612 6.07426 14.7931 6.32921 14.898 6.56764C15.3569 7.61256 16.4485 8.33933 17.5972 8.33898Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_13507_144791">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(2.5 2.00049)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
